import * as Yup from "yup";
import Messages from "../languages/Messages";

export const PaymentMethodGeneralSchema = Yup.object().shape({
    status: Yup.mixed().required("Required"),
});
